export const fieldsFormPassword = (): IFieldForm[] => {
    return [
        {
            id: 'itemformPassword',
            name: 'password',
            type: 'password',
            label: 'Ingrese nueva contraseña',
            placeholder: 'Nueva contraseña',
            required: true,
            maxLength: 50,
        },
        {
            id: 'itemformConfirmPassword',
            name: 'confirmPassword',
            type: 'password',
            label: 'Confirme nueva contraseña',
            placeholder: 'Confirme nueva contraseña',
            required: true,
            maxLength: 50,
        },
    ]
}

type IFieldForm = {
    id: string;
    name: string;
    type: string;
    label: string;
    placeholder: string;
    maxLength?: number;
    options?: any[];
    required: boolean;
}